
import Vue from 'vue'
import BigNumber from 'bignumber.js'

export default Vue.extend({
    data: () => {
        return {
            error: null as Error | null,
            tx: null as Connex.Thor.Transaction | null,
            receipt: null as Connex.Thor.Transaction.Receipt | null,
            id: ''
        }
    },
    computed: {
        clauses() { return this.tx!.clauses },
        totalTransferAmount() {
            let total = new BigNumber(0)
            this.clauses.forEach(c => {
                total = total.plus(c.value)
            })
            return total.toString()
        },
        vip191() { return !!(this.tx as any).delegator }
    },
    methods: {
        async reload() {
            this.error = null
            this.tx = null
            this.receipt = null

            try {
                const tv = this.$connex.thor.transaction(this.id).allowPending()
                const [tx, receipt] = await Promise.all([
                    tv.get(),
                    tv.getReceipt()
                ])

                if (tx) { this.tx = tx } else { this.error = new Error('not found') }
                if (receipt) { this.receipt = receipt }
            } catch (err) {
                this.error = err as Error
            }
        }
    },
    async created() {
        this.$ga.page('/insight/tx')
        this.id = this.$route.params.id
        this.reload()

        let destroyed = false
        this.$once('hook:beforeDestroy', () => {
            destroyed = true
        })

        const ticker = this.$connex.thor.ticker()
        const tv = this.$connex.thor.transaction(this.id)
        for (; ;) {
            await ticker.next()
            if (destroyed || this.receipt) {
                break
            }
            try {
                this.receipt = await tv.getReceipt()
            } catch { }
        }
    }
})
